'use strict';
import React, { useState, useEffect } from 'react';
import './App.css';

const PomodoroTimer = () => {
  const [status, setStatus] = useState('Stopped');
  const [intervalId, setIntervalId] = useState();
  const [isBreak, setIsBreak] = useState(false);
  const [remainingTime, setRemainingTime] = useState(25 * 60);

  useEffect(() => {
    return () => clearInterval(intervalId);
  }, [intervalId]);

  // handles button clicks
  const handleButtonClick = (click) => {
    if (click === 'Start') {
      startTimer();
    } else if (click === 'Stop') {
      stopTimer();
    } else if (click === 'Reset') {
      resetTimer();
    }
  };

  // start timer
  const startTimer = () => {
    if (status === 'Stopped') {
      setStatus('Active');
      const id = setInterval(() => {
        setRemainingTime((prevTime) => {
          if (prevTime <= 0) {
            clearInterval(id);
            setIsBreak(!isBreak);
            return isBreak ? 25 * 60 : 5 * 60; // switch between break and work time
          }
          return prevTime - 1;
        });
      }, 1000);
      setIntervalId(id);
    }
  };

  // stop timer
  const stopTimer = () => {
    if (status === 'Active') {
      setStatus('Stopped');
      clearInterval(intervalId);
    }
  };

  // reset timer
  const resetTimer = () => {
    setStatus('Stopped');
    clearInterval(intervalId);
    setIsBreak(false);
    setRemainingTime(25 * 60);
  };

  return (
    <div className="timer-container">
      <div className="timer">
        {`${Math.floor(remainingTime / 60)}:${remainingTime % 60 < 10 ? `0${remainingTime % 60}` : remainingTime % 60}`}
      </div>
      <div className="time-buttons">
        <div className="start">
          <button onClick={() => handleButtonClick('Start')} disabled={status === 'Active'}>
            START
          </button>
        </div>
        <div className="stop">
          <button onClick={() => handleButtonClick('Stop')} disabled={status !== 'Active'}>
            STOP
          </button>
        </div>
        <div className="reset">
          <button onClick={() => handleButtonClick('Reset')} >
            RESET
          </button>
        </div>
      </div>
    </div>
  );
};

export default PomodoroTimer;